import { Dispatch } from 'redux';
import { Services } from '../../types/services';

const SET_WORKFLOW_ACTIVE_PRACTICE = 'SET_WORKFLOW_ACTIVE_PRACTICE';
const SET_WORKFLOW_PRACTICES = 'SET_WORKFLOW_PRACTICES';
const SET_WORKFLOW_FILTER = 'SET_WORKFLOW_FILTER';
const SET_WORKFLOW_STATUS = 'SET_WORKFLOW_STATUS';

interface Practice {
  id?: string;
  name?: string;
  [key: string]: unknown;
}

interface WorkflowStatus {
  loading: boolean;
  searchingPractices: boolean;
  editingPractice: boolean;
  editingRelations: boolean;
}

interface State {
  practiceList: Practice[];
  workflowPractice: Practice;
  practiceFilter: string;
  workFlowStatus: WorkflowStatus;
}

const initialState: State = {
  practiceList: [],
  workflowPractice: {},
  practiceFilter: '',
  workFlowStatus: {
    loading: false,
    searchingPractices: true,
    editingPractice: false,
    editingRelations: false,
  },
};

interface Action {
  type: string;
  payload?: unknown;
}

export const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    case SET_WORKFLOW_FILTER:
      return {
        ...state,
        practiceFilter: action.payload as string,
      };
    case SET_WORKFLOW_PRACTICES:
      return {
        ...state,
        practiceList: action.payload as Practice[],
      };
    case SET_WORKFLOW_ACTIVE_PRACTICE:
      return {
        ...state,
        workflowPractice: action.payload as Practice,
      };
    case SET_WORKFLOW_STATUS:
      return {
        ...state,
        workFlowStatus: action.payload as WorkflowStatus,
      };
    default:
      return state;
  }
};

export const actions = (services: Services) => {
  const axiosService = services.axios.Axios();

  const setWorkflowFilter = (filter = '') => ({
    type: SET_WORKFLOW_FILTER,
    payload: filter,
  });

  const setWorkflowStatus = (status?: WorkflowStatus) => {
    const defaultStatus: WorkflowStatus = {
      loading: false,
      searchingPractices: true,
      editingPractice: false,
      editingRelations: false,
    };
    return {
      type: SET_WORKFLOW_STATUS,
      payload: status || defaultStatus,
    };
  };

  const setWorkflowWorkingPractice = (practice: Practice) => ({
    type: SET_WORKFLOW_ACTIVE_PRACTICE,
    payload: practice,
  });

  const getPractices = (filter = '') => {
    return async (dispatch: Dispatch) => {
      const params = { filter };
      const res = await axiosService.get<Practice[]>('practices/workflow/practices', { params });
      dispatch({ type: SET_WORKFLOW_PRACTICES, payload: res.data });
      return res;
    };
  };

  const getPractice = (id: string) => {
    return async (dispatch: Dispatch) => {
      const params = { getForWorkflow: true };
      const res = await axiosService.get<{ data: Practice }>('practices/' + id, { params });
      dispatch(setWorkflowWorkingPractice(res.data.data));
      return res;
    };
  };

  return {
    getPractice,
    getPractices,
    setWorkflowFilter,
    setWorkflowStatus,
    setWorkflowWorkingPractice,
  };
};

